define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function (csiAccess, access, full, readOnly) {
	const ExternalAPIAdminRoles = ['External API Administrator'];
	const ProductComplianceAnalysisAdmin = ['Product Compliance Analysis Administrator'];
	
	csiAccess.addViewRoles({
		"_CS_Data": {
			"FoodIngredients": {
				"ComplianceAnalysisBypass": access(full(ProductComplianceAnalysisAdmin))
			}
		},
		"_CS_Site": {
			"ProductComplianceAnalysisTypes": {
				"SyncParameters": access(full(ExternalAPIAdminRoles))
			}
		},
		"FoodLabelDataSheetRevision": {
			"FlatIngredientItems": {
				"ComplianceAnalysisBypass": access(full(ProductComplianceAnalysisAdmin))
			}
		}
	});
});